(() => {
  const setup = () => {
    const board = document.getElementById('b-4a');
    document.querySelectorAll('.kw-hdr').forEach(header => {
      if (header.querySelector('.kw-menu-toggle')) return;
      const nav = header.querySelector('nav');
      if (!nav) return;
      const menu = nav.cloneNode(true);
      menu.className = 'kw-mobile-nav';
      menu.removeAttribute('style');
      menu.id = 'kw-mobile-navigation';
      menu.hidden = true;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'kw-menu-toggle';
      button.textContent = board.dataset.menuLabel;
      button.setAttribute('aria-expanded','false'); button.setAttribute('aria-controls', menu.id);
      const close = () => {menu.hidden=true;button.setAttribute('aria-expanded','false');};
      button.addEventListener('click', () => {menu.hidden=!menu.hidden;button.setAttribute('aria-expanded',String(!menu.hidden));});
      menu.addEventListener('click', e => {if(e.target.closest('a')) close();});
      header.addEventListener('keydown', e => {if(e.key === 'Escape'){close();button.focus();}});
      header.append(button,menu);
    });
    document.querySelectorAll('input[type="date"]').forEach(input => {
      const now=new Date();input.min=new Date(now.getTime()-now.getTimezoneOffset()*60000).toISOString().slice(0,10);
    });
  };
  setup(); document.addEventListener('shopify:section:load',setup);
})();
